import { entryKeys } from "./participantIdentity"

// A seed is recorded on the draw position (`seeded`) and its number rides on the entry's
// `competitionRank`; group draws seed the top `numberOfGroups` entries as group heads.
// Every page (Entry Lists, Lucky Draw, Main Draw) shows it the same way: "[n]" after the name.
// P54: the Tenis10 rules have no seeds (regulation § 2.6), so a Tenis10 competition (its category) and a child's slot (a child
// only plays Tenis10) never show one, whatever the draw recorded.
export const seedless = (person, competition) => Boolean(competition?.tenis10Level || person?.profileId)

export const isSeeded = ({ seeded, competitionRank, profileId } = {}, competition) =>
  !seedless({ profileId }, competition) && (seeded === true ||
  (competition?.drawModel === "groups" && Number(competitionRank) > 0 && Number(competitionRank) <= Number(competition?.numberOfGroups)))

export const seedRankOf = (position, entry, competition) =>
  isSeeded({ seeded: position?.seeded, competitionRank: entry?.competitionRank, profileId: entry?.profileId }, competition) ? entry?.competitionRank ?? "—" : undefined

// A Lucky Draw slot is a copy of its entry: both are keyed by their people (participantIdentity.js) — a
// Tenis10 child by its profileId, never by the parent's account its siblings share (PRD 16 LR11c).
const teamKey = entry => entryKeys(entry).join("/") || null

// Entry Lists have no seed of their own: the seed comes from the Lucky Draw, keyed by the
// entry id and, for older draws that carry no id, by the team's people.
export const luckyDrawSeeds = competition => {
  const seeds = new Map()
  ;(Array.isArray(competition?.luckyDraw) ? competition.luckyDraw : []).forEach(row => {
    const rank = seedRankOf(row, row.slot, competition)
    if (rank === undefined) return
    if (row.slot?._id) seeds.set(String(row.slot._id), rank)
    const key = teamKey(row.slot)
    if (key) seeds.set(key, rank)
  })
  return entry => seeds.get(String(entry?._id)) ?? seeds.get(teamKey(entry))
}
